/* Kaufbereich Windlicht „Familie" – siehe snippets/windlicht-familie.liquid */
(() => {
  const root = document.querySelector('[data-wlf]');
  if (!root) return;

  const SLOTS = root.dataset.slots.split(',');
  const LAYOUTS = root.dataset.layout.split('|').map((s) => s.split(',').map(Number));
  const MAX_LEN = Number(root.dataset.maxlen) || 14;
  // Beispielnamen je Platz – gleich den Standardtexten im teeinblue-Artwork „Familie"
  const EXAMPLES = ['Mama', 'Lena', 'Papa', 'Ben', 'Emma', 'Mia', 'Noah'];
  let count = Number(root.dataset.default) || 4;
  const names = [];

  const benefits = root.querySelector('[data-wlf-benefits]');
  const delivery = root.querySelector('[data-wlf-delivery]');
  const konfig = root.querySelector('[data-wlf-konfig]');
  const countsBox = root.querySelector('[data-wlf-counts]');
  const namesBox = root.querySelector('[data-wlf-names]');
  const errBox = root.querySelector('[data-wlf-err]');
  const sticky = document.querySelector('[data-wlf-sticky]');

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  async function waitFor(fn, timeout = 20000, step = 150) {
    const start = Date.now();
    while (Date.now() - start < timeout) {
      const v = fn();
      if (v) return v;
      await sleep(step);
    }
    return null;
  }
  const el = (tag, cls, text) => {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  };

  // ---------- Lieferdatum ----------
  const HOLIDAYS = ['2026-12-25', '2026-12-26', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-17', '2027-10-03', '2027-12-25', '2027-12-26'];
  const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const isWorkday = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !HOLIDAYS.includes(iso(d));
  function addWorkdays(d, n) {
    const x = new Date(d);
    while (n > 0) {
      x.setDate(x.getDate() + 1);
      if (isWorkday(x)) n--;
    }
    return x;
  }
  function renderDelivery() {
    const now = new Date();
    // bis 14 Uhr an Werktagen bestellt = heute verschickt, sonst am nächsten Werktag; Zustellung 1–2 Werktage
    const ship = isWorkday(now) && now.getHours() < 14 ? now : addWorkdays(now, 1);
    const fmt = (d) => d.toLocaleDateString('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
    delivery.textContent = `📦 Lieferung voraussichtlich ${fmt(addWorkdays(ship, 1))} – ${fmt(addWorkdays(ship, 2))}`;
    delivery.hidden = false;
  }

  // ---------- teeinblue im Hintergrund steuern ----------
  const field = (layer) => document.querySelector('form.tee-form-wrapper .tee-field--' + layer);
  const setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  let pending = 0;

  async function setSlot(layer, on, value) {
    const f = field(layer);
    if (!f) return;
    const sw = f.querySelector('.tee-switch__input');
    if (sw && sw.checked !== on) {
      // Klick auf den (unsichtbaren) teeinblue-Schalter darf weder scrollen noch den Fokus klauen
      const sx = window.scrollX;
      const sy = window.scrollY;
      const active = document.activeElement;
      const restore = () => {
        if (window.scrollY !== sy || window.scrollX !== sx) window.scrollTo(sx, sy);
        if (active && active !== document.body && document.contains(active) && document.activeElement !== active) active.focus({ preventScroll: true });
      };
      f.querySelector('.tee-switch__label').click();
      restore();
      await waitFor(() => f.querySelector('.tee-switch__input').checked === on, 1500, 40);
      restore();
    }
    if (!on) return;
    const inp = await waitFor(() => f.querySelector('input.tee__input--text'), 1500, 40);
    if (!inp || inp.value === value) return;
    setValue.call(inp, value);
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // alle Plätze passend zur Anzahl schalten und befüllen (nacheinander, damit teeinblue mitkommt)
  let queue = Promise.resolve();
  function sync() {
    pending++;
    queue = queue
      .then(async () => {
        const used = LAYOUTS[count - 1];
        for (let s = 1; s <= SLOTS.length; s++) {
          const k = used.indexOf(s);
          await setSlot(SLOTS[s - 1], k >= 0, k >= 0 ? (names[k] || '').trim() : '');
        }
      })
      .catch(() => {})
      .finally(() => { pending--; });
    return queue;
  }
  function syncName(i) {
    pending++;
    queue = queue
      .then(() => setSlot(SLOTS[LAYOUTS[count - 1][i] - 1], true, (names[i] || '').trim()))
      .catch(() => {})
      .finally(() => { pending--; });
  }

  // ---------- Oberfläche ----------
  function renderCounts() {
    countsBox.textContent = '';
    for (let n = 1; n <= SLOTS.length; n++) {
      const b = el('button', 'wlf__count' + (n === count ? ' is-on' : ''), String(n));
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', n === count ? 'true' : 'false');
      b.setAttribute('aria-label', n === 1 ? '1 Name' : `${n} Namen`);
      b.addEventListener('click', () => {
        if (n === count) return;
        count = n;
        errBox.textContent = '';
        renderCounts();
        renderNames();
        sync();
      });
      countsBox.appendChild(b);
    }
  }

  function renderNames() {
    namesBox.textContent = '';
    for (let i = 0; i < count; i++) {
      const row = el('label', 'wlf__name');
      const top = el('span', 'wlf__name-top');
      top.append(el('span', 'wlf__name-label', count === 1 ? 'Name' : `Name ${i + 1}`));
      const counter = el('span', 'wlf__name-count', `${(names[i] || '').length}/${MAX_LEN}`);
      top.append(counter);
      const inp = el('input', 'wlf__name-input');
      inp.type = 'text';
      inp.maxLength = MAX_LEN;
      inp.autocomplete = 'off';
      inp.placeholder = 'z. B. ' + EXAMPLES[LAYOUTS[count - 1][i] - 1];
      inp.value = names[i] || '';
      inp.addEventListener('input', () => {
        names[i] = inp.value;
        counter.textContent = `${inp.value.length}/${MAX_LEN}`;
        row.classList.remove('is-missing');
        if (errBox.textContent) errBox.textContent = '';
        syncName(i);
      });
      row.append(top, inp);
      namesBox.appendChild(row);
    }
  }

  function missingNames() {
    const miss = [];
    for (let i = 0; i < count; i++) if (!(names[i] || '').trim()) miss.push(i);
    return miss;
  }

  // Warenkorb nur mit vollständigen Namen; offene Abgleiche vorher abwarten
  let bypass = false;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('form.tee-form-wrapper .tee-btn--atc');
    if (!btn || bypass || !document.documentElement.classList.contains('wlf-on')) return;
    const miss = missingNames();
    if (miss.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      errBox.textContent = miss.length === 1
        ? `Bitte trag noch ${count === 1 ? 'den Namen' : `Name ${miss[0] + 1}`} ein – oder wähle weniger Namen.`
        : `Bitte trag noch ${miss.length} Namen ein – oder wähle weniger Namen.`;
      const rows = namesBox.querySelectorAll('.wlf__name');
      miss.forEach((i) => rows[i] && rows[i].classList.add('is-missing'));
      konfig.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const first = rows[miss[0]] && rows[miss[0]].querySelector('input');
      if (first) setTimeout(() => first.focus({ preventScroll: true }), 350);
      return;
    }
    if (pending > 0) {
      e.preventDefault();
      e.stopImmediatePropagation();
      await queue;
      bypass = true;
      btn.click();
      bypass = false;
    }
  }, true);

  // ---------- Handy: fester „Jetzt gestalten"-Knopf ----------
  function setupSticky() {
    if (!sticky || !('IntersectionObserver' in window)) return;
    const mq = window.matchMedia('(max-width: 999px)');
    const seen = new Map();
    const update = () => {
      const anyVisible = [...seen.values()].some(Boolean);
      sticky.hidden = !mq.matches || anyVisible;
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => seen.set(en.target, en.isIntersecting));
      update();
    });
    io.observe(konfig);
    const atc = document.querySelector('form.tee-form-wrapper .tee-form-actions');
    if (atc) io.observe(atc);
    mq.addEventListener ? mq.addEventListener('change', update) : mq.addListener(update);
    sticky.addEventListener('click', () => {
      konfig.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const empty = [...namesBox.querySelectorAll('input')].find((i) => !i.value.trim());
      if (empty) setTimeout(() => empty.focus({ preventScroll: true }), 400);
    });
  }

  // ---------- Einbau an die richtigen Stellen ----------
  function place() {
    const form = document.querySelector('form.tee-form-wrapper');
    const main = form && form.querySelector('.tee-customize-main-form');
    if (main && konfig.nextElementSibling !== main) main.parentNode.insertBefore(konfig, main);
    const anchor = document.querySelector('.product-meta__taxes-included') || document.querySelector('.product-meta__price-list-container');
    if (anchor && benefits.previousElementSibling !== anchor && !anchor.parentNode.contains(benefits)) {
      anchor.insertAdjacentElement('afterend', benefits);
      benefits.insertAdjacentElement('afterend', delivery);
    }
  }

  async function init() {
    renderDelivery();
    const ok = await waitFor(() => field(SLOTS[0]) && document.querySelector('form.tee-form-wrapper .tee-customize-main-form'));
    if (!ok) return; // teeinblue nicht da → normales Formular bleibt
    renderCounts();
    renderNames();
    place();
    document.documentElement.classList.add('wlf-on');
    await sync();
    setupSticky();
    // teeinblue rendert bei Farbwechsel teilweise neu → wieder einsetzen und abgleichen
    const form = document.querySelector('form.tee-form-wrapper');
    let t = null;
    new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(() => {
        if (!form.contains(konfig)) place();
        const used = LAYOUTS[count - 1];
        const wrong = SLOTS.some((layer, idx) => {
          const sw = field(layer) && field(layer).querySelector('.tee-switch__input');
          return sw && sw.checked !== used.includes(idx + 1);
        });
        if (wrong && pending === 0) sync();
      }, 250);
    }).observe(form, { childList: true, subtree: true });
  }

  init();
})();
